import { Label, Typography } from '@musinsa/mds';
import type { FC } from 'react';

const DISPLAY_NAME = 'ProductInformation.LowestPriceBadge';

interface Props {
  className?: string;
}

export const LowestPriceBadge: FC<Props> = ({ className }) => (
  <Label variant="grayOpacity" className={className}>
    <Typography size="11">최저가도전</Typography>
  </Label>
);

LowestPriceBadge.displayName = DISPLAY_NAME;
